module.exports = __webpack_public_path__ + "img/lt.315aa369.svg";